<template>
  <div class="condition-group">
    <condition-row
      v-for="condition in group"
      :key="condition.id"
      :condition="condition"
      :fieldOptions="fieldOptions"
      :operatorOptions="operatorOptions"
      :valueOptions="valueOptions"
      :dragId="dragId"
      :allowSubgroup="level === 0"
      :isEditable="isEditable"
      @update-condition="updateCondition"
      @remove-condition="removeCondition"
      @add-subgroup="addCondition"
      @drag-start="onDragStart"
      @drop="onDrop"
    >
      <template #nested>
        <div v-if="condition.children && condition.children.length > 0" class="nested">
          <condition-group
            :group="condition.children"
            :newCondition="newCondition"
            :newSubgroup="newSubgroup"
            :parentId="condition.id"
            :level="level + 1"
            :treeManager="treeManager"
            :selectedFeatureId="selectedFeatureId"
            :isEditable="isEditable"
          />
        </div>
      </template>
    </condition-row>

    <!-- <div class="add-actions">
      <button class="add-btn" type="button" @click="addCondition(parentId)">
        <span>+</span> Add condition
      </button>
    </div> -->
  </div>
</template>

<script>
import ConditionRow from '@/components/workflows/conditionRow.vue'
import config from '@/config'

export default {
  name: 'ConditionGroup',
  components: { ConditionRow },
  props: {
    group: {
      type: Array,
      required: true
    },
    newCondition: {
      type: Function,
      required: true
    },
    newSubgroup: {
      type: Function,
      required: true
    },
    parentId: {
      type: [Number, String],
      default: null
    },
    treeManager: {
      type: Object,
      required: true
    },
    selectedFeatureId: {
      type: Number,
      default: null
    },
    level: {
      type: Number,
      default: 0
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // previous field options retained for future use:
      // fieldOptions: [
      //   { name: 'Forecast category', id: 'Forecast category' },
      //   { name: 'Stage', id: 'Stage' },
      //   { name: 'OHS', id: 'OHS' },
      //   { name: 'Opportunity owner', id: 'Opportunity owner' },
      //   { name: 'Close date', id: 'Close date' },
      //   { name: 'Amount', id: 'Amount' }
      // ],
      operatorOptions: [
        { name: 'is', id: 'is' },
        { name: 'contains', id: 'contains' }
      ],
      dragId: null
    }
  },
  computed: {
    fieldOptions () {
      const fieldName = this.selectedFeatureId === config.CORE_FEATURES.BOM || this.selectedFeatureId === config.CORE_FEATURES.DOCUMENTS
        ? 'state'
        : 'status'
      return [{ name: fieldName, id: fieldName }]
    },
    valueOptions () {
      if (this.selectedFeatureId === config.CORE_FEATURES.MATERIAL) {
        return Object.keys(config.MATERIAL_STATUS_MAP || {}).map(key => ({
          id: Number(key),
          name: config.MATERIAL_STATUS_MAP[key]
        }))
      }
      if (this.selectedFeatureId === config.CORE_FEATURES.BOM) {
        return Object.keys(config.BOM_STATE_MAP || {}).filter(key => config.BOM_STATE_MAP[key] !== config.BOM_STATE_MAP.CHECKOUT).map(key => ({
          id: Number(config.BOM_STATE_MAP[key]),
          name: key
        }))
      }
      if (this.selectedFeatureId === config.CORE_FEATURES.DOCUMENTS) {
        return Object.keys(config.DOC_STATE || {}).filter(key => Number(key) !== config.DOC_STATE_MAP.CHECKOUT).map(key => ({
          id: Number(key),
          name: config.DOC_STATE[key]
        }))
      }
      if (this.selectedFeatureId === config.CORE_FEATURES.FORMS) {
        return Object.keys(config.FORM_STATE || {}).map(key => ({
          id: Number(key),
          name: config.FORM_STATE[key]
        }))
      }
      return []
    }
  },
  methods: {
    updateCondition ({ id, patch }) {
      this.treeManager.updateNode(id, patch)
      if (this.level === 1 && Object.prototype.hasOwnProperty.call(patch, 'logicalOperator')) {
        this.group
          .filter(item => item.id !== id)
          .forEach(item => this.treeManager.updateNode(item.id, { logicalOperator: patch.logicalOperator }))
      }
    },
    addCondition (parentId) {
      const nodePayload = {}
      if (this.level === 0 && parentId) {
        const siblingSubgroups = this.treeManager
          .getFlat()
          .filter(item => item.parentId === parentId)
        if (siblingSubgroups.length > 0) {
          nodePayload.logicalOperator = siblingSubgroups[0].logicalOperator || 'and'
        }
      }
      this.treeManager.addNode(parentId, nodePayload)
    },
    removeCondition (id) {
      this.treeManager.deleteNode(id)
    },
    onDragStart ({ condition }) {
      this.dragId = condition.id
    },
    onDrop () {
      this.dragId = null
    }
  }
}
</script>

<style scoped lang="scss">
$color-primary: #7c3aed;
$color-primary-focus-bg: #f5f3ff;
$color-bg-surface: #f9fafb;
$color-border-base: #e5e7eb;
$font-size-sm: 12px;

.condition-group {
  background: transparent;
}

.nested {
  background: $color-bg-surface;
  border: 1px solid $color-border-base;
  border-radius: 8px;
  padding: 10px;
  margin-top: 8px;
}

.add-actions {
  display: flex;
  gap: 12px;
  padding: 6px 0 4px;
}

.add-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: $color-primary;
  font-size: $font-size-sm;
  font-weight: 500;
  padding: 4px 6px;
  border-radius: 4px;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: $color-primary-focus-bg;
  }
}
</style>
